import type { CityConfig } from "../city-template/types";

export const kansasCityConfig: CityConfig = {
  city: "Kansas City",
  state: "Missouri",
  stateAbbr: "MO",
  slug: "kansas-city",
  route: "/kansas-city",
  title: "Emergency Passport Kansas City, KS — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Kansas City, KS — as fast as 24 hours. Fast passport renewal, same-day help, and lost passport replacement. A+ BBB rated, registered State Dept. courier serving Kansas City and the metro area.",
  h1: "Emergency & Expedited Passport Services in Kansas City, Kansas",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport, fast passport renewal, or same-day help? We help Kansas City and Western Kansas travelers get their urgent passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Kansas%20City%20skyline%20at%20sunset%20with%20Union%20Station%20and%20Liberty%20Memorial%20visible%2C%20downtown%20skyscrapers%20reflecting%20warm%20golden%20light%2C%20Missouri%20River%20in%20foreground%2C%20warm%20amber%20and%20orange%20tones%20across%20the%20sky%2C%20professional%20cityscape%20photography%2C%20panoramic%20view%2C%20no%20visible%20text%20or%20people%2C%20clean%20modern%20urban%20scene%20with%20fountains%20and%20plazas&width=1800&height=700&seq=kc-hero-001&orientation=landscape",
  heroImageAlt: "Kansas City skyline at sunset with Union Station and downtown skyscrapers",
  geoPosition: "39.0997;-94.5786",
  geoPlacename: "Kansas City, Missouri",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Chicago is the nearest regional passport agency — approximately 8 hours from Kansas City by car. Fast Passport Center eliminates the need for this drive with our registered courier service.",
  },
  nearbyCitiesZips: [
    { name: "Downtown Kansas City", zips: "64105–64108" },
    { name: "Overland Park", zips: "66204, 66207, 66210, 66212, 66213, 66214, 66221, 66223" },
    { name: "Independence", zips: "64050, 64052, 64055, 64057" },
    { name: "Lee's Summit", zips: "64063, 64064, 64081, 64082, 64086" },
    { name: "Olathe", zips: "66061, 66062" },
    { name: "Shawnee", zips: "66203, 66216, 66217, 66218, 66226, 66227" },
    { name: "Blue Springs", zips: "64014, 64015" },
    { name: "Liberty", zips: "64068, 64069" },
    { name: "Gladstone", zips: "64118, 64119" },
    { name: "Raytown", zips: "64133, 64138" },
    { name: "Grandview", zips: "64030" },
    { name: "Belton", zips: "64012" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Kansas City departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels to our processing center" },
  ],
  internalLinks: [
    { name: "Fast passport renewal in St. Louis", route: "/st-louis" },
    { name: "Emergency passport help in Springfield", route: "/springfield-mo" },
    { name: "Urgent passport services in Columbia", route: "/columbia-mo" },
    { name: "Expedited passport services in Missouri", route: "/missouri" },
    { name: "Fast passport renewal in Chicago", route: "/illinois" },
    { name: "Passport courier services in Des Moines", route: "/des-moines" },
    { name: "Rush passport help in Indianapolis", route: "/indianapolis" },
  ],
  fpcOfficeAddress: "1200 Main St, Kansas City, MO 64105",
  fpcOfficeNote: "Visit the Fast Passport Center office at 1200 Main St in downtown Kansas City — appointment suggested. Sign up on our website first to schedule your visit. We offer full-service expedited and emergency passport processing for Kansas City and metro area travelers.",
  fpcOfficeDistance: "Located in downtown Kansas City — serving the entire KC metro area",
  mapEmbedUrl: "https://www.google.com/maps?q=1200+Main+St,+Kansas+City,+MO+64105&output=embed",
  serviceAreaIntro: "Fast Passport Center provides emergency and fast passport renewal services throughout the entire Kansas City metro area. From downtown KC to Overland Park, from Independence to Lee's Summit — we help Kansas City travelers get their passports fast, often in 24–48 hours through our registered courier service.",
  nearbyCitiesIntro: "We serve all Kansas City neighborhoods and nearby cities including Overland Park, Independence, Lee's Summit, Blue Springs, Liberty, and Gladstone. If you are in Jackson County or across the line in Kansas, we have you covered.",
  howItWorksIntro: "Most Kansas City travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait for standard mail. Our emergency and expedited passport process is designed for Kansas City travelers who need fast, reliable results.",
  mistakesIntro: "With Kansas City International Airport serving as a major hub, KC travelers can't afford passport delays. Here are the most common mistakes we see.",
  testimonialsIntro: "Kansas City travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Kansas City? Here are the most common ones we hear from Jackson County travelers.",
  statePageRoute: "/states/missouri",
  statePageName: "Missouri",
  hasPhysicalOffice: true,
  officePhone: "(877) 253-0084",
  officeHours: [
    { days: "Mon–Fri", hours: "9:00 AM – 6:00 PM" },
    { days: "Saturday", hours: "10:00 AM – 2:00 PM" },
    { days: "Sunday", hours: "Closed" },
  ],
  officePhotoUrl: "https://storage.readdy-site.link/project_files/5b15eb5b-af79-4c03-9ad0-73c6095d69a7/f7518966-e102-4344-9177-9a3eef5c4c02_compressed_kansas-city-mo-fast-passport-center-office.webp",
  officePhotoAlt: "Fast Passport Center office at 1200 Main St in downtown Kansas City — the actual building with Fast Passport Center signage and the iconic One Kansas City Place tower visible in the skyline behind",
  exploreNearbyHeading: "Explore Nearby City Pages",
  areaServedList: [
    { "@type": "City", "name": "Kansas City" },
    { "@type": "City", "name": "Overland Park" },
    { "@type": "City", "name": "Independence" },
    { "@type": "City", "name": "Lee's Summit" },
    { "@type": "City", "name": "Olathe" },
    { "@type": "City", "name": "Shawnee" },
    { "@type": "City", "name": "Blue Springs" },
    { "@type": "City", "name": "Liberty" },
    { "@type": "City", "name": "Gladstone" },
    { "@type": "City", "name": "Raytown" },
    { "@type": "City", "name": "Grandview" },
    { "@type": "City", "name": "Belton" },
    { "@type": "AdministrativeArea", "name": "Jackson County" },
    { "@type": "AdministrativeArea", "name": "Johnson County" },
    { "@type": "AdministrativeArea", "name": "Clay County" },
  ],
  serviceAreaDesc: "Fast Passport Center is a registered U.S. Department of State passport courier with an office at 1200 Main St in downtown Kansas City. We provide expedited and emergency passport services as fast as 24 hours to Kansas City, Overland Park, Independence, Lee's Summit, and all Kansas City metro communities across Jackson, Johnson, and Clay counties. A+ BBB rated.",
  landmarks: [
    { name: "Kansas City International Airport (MCI)", distance: "15 miles", icon: "ri-plane-line", desc: "Primary airport serving the KC metro area with domestic and international flights." },
    { name: "Union Station", distance: "0.8 miles", icon: "ri-train-line", desc: "Historic railroad station and cultural hub in downtown Kansas City." },
    { name: "Power & Light District", distance: "0.3 miles", icon: "ri-building-line", desc: "Downtown entertainment district with dining, nightlife, and events." },
    { name: "Country Club Plaza", distance: "3 miles", icon: "ri-shopping-bag-line", desc: "Iconic outdoor shopping district with Spanish-inspired architecture." },
    { name: "World War I Museum & Memorial", distance: "0.6 miles", icon: "ri-map-pin-line", desc: "National museum honoring WWI veterans at the Liberty Memorial." },
    { name: "Arrowhead Stadium", distance: "7 miles", icon: "ri-football-line", desc: "Home of the Kansas City Chiefs — one of the loudest stadiums in the NFL." },
    { name: "T-Mobile Center", distance: "0.4 miles", icon: "ri-music-line", desc: "Premier arena hosting concerts, sports, and major events downtown." },
    { name: "Nelson-Atkins Museum of Art", distance: "2.5 miles", icon: "ri-palette-line", desc: "World-renowned art museum with an iconic shuttlecock sculpture lawn." },
  ],
  dmvWebsite: "https://dor.mo.gov/motor-vehicle",
  dmvLabel: "Missouri Motor Vehicle — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns and budget fights",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Kansas City travelers with immediate departure needs — as fast as 24 hours for urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Robert H.",
      location: "Overland Park, KS",
      rating: 5,
      text: "My flight to Tokyo was in 3 days and my passport was expired. Fast Passport Center got me a new one in 36 hours. Absolutely saved my business trip.",
      service: "Emergency Passport",
    },
    {
      name: "Amanda L.",
      location: "Lee's Summit, MO",
      rating: 5,
      text: "I needed to renew my passport for a family vacation to Cancun. The process was smooth, they reviewed my documents, and I had my passport in 4 days. Highly recommend.",
      service: "Passport Renewal",
    },
    {
      name: "Carlos M.",
      location: "Independence, MO",
      rating: 5,
      text: "Lost my passport the week before my honeymoon to Greece. They walked me through the DS-64 process and got me a replacement in 2 days. Incredible service.",
      service: "Lost Passport",
    },
    {
      name: "Sarah K.",
      location: "Liberty, MO",
      rating: 5,
      text: "As a frequent international traveler, I can't afford passport delays. Fast Passport Center has been my go-to for years. Professional, fast, and reliable every time.",
      service: "Expedited Renewal",
    },
  ],
  facilities: [
    {
      id: "kc-1",
      name: "Kansas City Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "300 W Pershing Rd",
      city: "Kansas City",
      state: "MO",
      zip: "64108",
      phone: "(816) 374-9002",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.5 miles from downtown Kansas City",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Acceptance hours are limited. Appointments required. Call ahead to confirm passport acceptance times.",
      icon: "ri-mail-line",
    },
    {
      id: "kc-2",
      name: "Overland Park Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "6520 W 95th St",
      city: "Overland Park",
      state: "KS",
      zip: "66212",
      phone: "(913) 341-8642",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.3 miles from Overland Park central",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Busy location — book appointments 2+ weeks in advance. Limited weekend hours.",
      icon: "ri-mail-line",
    },
    {
      id: "kc-3",
      name: "Independence Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "300 W Lexington Ave",
      city: "Independence",
      state: "MO",
      zip: "64050",
      phone: "(816) 252-3100",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.5 miles from Independence Square",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Popular for Eastern Jackson County residents. Appointment strongly recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "kc-4",
      name: "Lee's Summit City Clerk",
      type: "City Clerk Passport Acceptance",
      address: "220 SE Green St",
      city: "Lee's Summit",
      state: "MO",
      zip: "64063",
      phone: "(816) 969-1000",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "0.2 miles from downtown Lee's Summit",
      website: "https://www.cityofls.net/",
      websiteLabel: "Lee's Summit City Clerk",
      notes: "Accepts walk-ins but appointments preferred. Photo services available on-site.",
      icon: "ri-government-line",
    },
    {
      id: "kc-5",
      name: "Blue Springs Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "501 NW Mock Ave",
      city: "Blue Springs",
      state: "MO",
      zip: "64014",
      phone: "(816) 228-5300",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "1 mile from Blue Springs City Hall",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Eastern Jackson County residents. Limited passport hours — call to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "kc-6",
      name: "Jackson County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "415 E 12th St",
      city: "Kansas City",
      state: "MO",
      zip: "64106",
      phone: "(816) 881-3232",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "0.3 miles from downtown Kansas City",
      website: "https://www.jacksongov.org/",
      websiteLabel: "Jackson County Clerk",
      notes: "Major county facility with extended hours. Accepts walk-ins but appointments recommended for faster service.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 8-hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "KC photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Kansas City acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many KC applicants show up with incorrect checks and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Chicago regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Kansas City families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "KC travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Kansas City." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Kansas City address — trackable every step of the way." },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in Kansas City?",
      a: "Fast Passport Center offers emergency passport processing in Kansas City in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, bypassing standard mail delays. This is the fastest reliable option for Kansas City travelers with urgent international flights.",
    },
    {
      q: "Can I get a same-day passport in Kansas City?",
      a: "Same-day passports are only available at regional passport agencies for documented life-or-death emergencies with proof of travel within 72 hours. The nearest agency to Kansas City is in Chicago, an 8-hour drive. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option available to Kansas City residents.",
    },
    {
      q: "Where can I get a fast passport renewal in Kansas City?",
      a: "Fast Passport Center offers fast passport renewal in Kansas City with no office visit required. We serve all Kansas City neighborhoods including Overland Park, Independence, Lee's Summit, Blue Springs, and Liberty. Simply complete your application online, ship your documents using our prepaid overnight label, and our couriers handle the rest.",
    },
    {
      q: "What is the fastest way to get an urgent passport in Kansas City?",
      a: "The fastest way to get an urgent passport in Kansas City is through Fast Passport Center's emergency courier service. Our registered couriers deliver your documents directly to State Department processing facilities, achieving 24–48 hour turnaround. This is significantly faster than standard mail processing (8–11 weeks) or even government expedited mail (3–5 weeks).",
    },
    {
      q: "How fast can I get a passport in Kansas City?",
      a: "With Fast Passport Center's emergency courier service, Kansas City travelers can receive their passport in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays.",
    },
    {
      q: "Do I need to drive to the Chicago Passport Agency?",
      a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change.",
    },
    {
      q: "Where are the closest passport acceptance facilities in Kansas City?",
      a: "Popular options include the Kansas City Main Post Office (64108), Overland Park Post Office (66212), Independence Post Office (64050), and Lee's Summit City Clerk (64063). All require appointments. We help you find the most convenient location and schedule your visit.",
    },
    {
      q: "What if I live in Overland Park or on the Kansas side?",
      a: "We serve all of the Kansas City metro area including Overland Park, Olathe, Shawnee, and Leawood in Kansas. Our overnight shipping labels work from any UPS location, so your location on either side of the state line doesn't affect processing speed.",
    },
    {
      q: "How much does expedited passport service cost in Kansas City?",
      a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24–48 hour processing, 3–5 day expedited, or standard options. Contact us for a personalized quote based on your timeline.",
    },
    {
      q: "Do you help with passport photos in Kansas City?",
      a: "We guide you on exact photo requirements and can recommend locations near you. Many CVS, Walgreens, and FedEx locations in Kansas City offer passport photo services. We review your photos before submission to ensure they meet State Department standards.",
    },
    {
      q: "What documents do I need for a first-time passport in Kansas City?",
      a: "You'll need proof of citizenship (birth certificate or naturalization certificate), government-issued photo ID (driver's license or REAL ID), two passport photos, and payment. We provide a complete checklist and review your documents before you visit the acceptance clerk.",
    },
    {
      q: "Can you help with a child's passport in Kansas City?",
      a: "Yes. Child passports require both parents (or notarized consent from the absent parent), the child's birth certificate, and both parents' IDs. We walk Kansas City families through the entire process and help schedule acceptance clerk appointments.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Overland Park", address: "7201 W 95th St, Overland Park, KS 66212", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Independence", address: "16920 E US Highway 24, Independence, MO 64056", hours: "Mon–Sun: 7AM–11PM" },
    { name: "FedEx Office — Downtown KC", address: "1101 Main St, Kansas City, MO 64105", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
    { name: "UPS Store — Lee's Summit", address: "830 NW Blue Pkwy, Lee's Summit, MO 64086", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "Walmart — Blue Springs", address: "600 NE Coronado Dr, Blue Springs, MO 64014", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Rite Aid — Liberty", address: "960 W Liberty Dr, Liberty, MO 64068", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Postal Annex — Gladstone", address: "7117 N Oak Trafficway, Gladstone, MO 64118", hours: "Mon–Fri: 9AM–6PM, Sat: 9AM–4PM" },
    { name: "Costco — Overland Park", address: "12200 W 87th St Pkwy, Lenexa, KS 66215", hours: "Mon–Fri: 10AM–8:30PM, Sat–Sun: 9:30AM–6PM" },
  ],
  dmvLocations: [
    {
      name: "DMV — Kansas City",
      address: "615 E 13th St, Kansas City, MO 64106",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and driver's license renewals. Appointment required.",
      featured: true,
    },
    {
      name: "DMV — Overland Park",
      address: "7501 W 115th St, Overland Park, KS 66213",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Passport-ready photo services available. Online appointment booking.",
      featured: false,
    },
    {
      name: "DMV — Independence",
      address: "1500 E 23rd St S, Independence, MO 64055",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID processing. Walk-ins limited — book online first.",
      featured: false,
    },
    {
      name: "DMV — Lee's Summit",
      address: "1530 NE Douglas St, Lee's Summit, MO 64086",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Full-service center for Eastern Jackson County residents.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "MCI",
      name: "Kansas City International Airport",
      distance: "15 miles from downtown Kansas City",
      address: "1 International Square, Kansas City, MO 64153",
      note: "The primary airport for Kansas City. Major hub for domestic flights with international connections to Canada, Mexico, and Europe.",
      flightUrl: "https://www.flykci.com/",
      flightLabel: "MCI Airport Info",
      featured: true,
    },
    {
      code: "MKC",
      name: "Charles B. Wheeler Downtown Airport",
      distance: "3 miles from downtown Kansas City",
      address: "300 Richards Rd, Kansas City, MO 64116",
      note: "General aviation airport near downtown KC. Primarily private and corporate flights.",
      flightUrl: "https://www.kcmo.gov/",
      flightLabel: "Wheeler Airport Info",
      featured: false,
    },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { label: "Birth Certificate", agency: "Missouri Department of Health & Senior Services", address: "930 Wildwood Dr, Jefferson City, MO 65109", url: "https://health.mo.gov/data/vitalrecords/" },
    { label: "Death Certificate", agency: "Missouri Department of Health & Senior Services", address: "930 Wildwood Dr, Jefferson City, MO 65109", url: "https://health.mo.gov/data/vitalrecords/" },
    { label: "Marriage Certificate", agency: "Jackson County Recorder of Deeds", address: "415 E 12th St, Kansas City, MO 64106", url: "https://www.jacksongov.org/recorder" },
    { label: "Divorce Decree", agency: "Jackson County Circuit Court", address: "415 E 12th St, Kansas City, MO 64106", url: "https://www.courts.mo.gov/" },
  ],
};